/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_In_TransitInputs */

const en_inbound_status_in_transit = /** @type {(inputs: Inbound_Status_In_TransitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In transit`)
};

/**
* | output |
* | --- |
* | "In transit" |
*
* @param {Inbound_Status_In_TransitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_in_transit = /** @type {((inputs?: Inbound_Status_In_TransitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_In_TransitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_in_transit(inputs)
});